/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IDobbiesFooterNewsletterViewProps } from './dobbies-footer-newsletter';

export default (props: IDobbiesFooterNewsletterViewProps) => {
    const { moduleProps, contentProps, newsletterheading, newsletterDescription, joinNow, subscribeForm } = props;

    /* VSI Customization - START */
    /*  condition either to show or hide the footer newsletter  */

    if (props.context.request.query!.onlyBody && props.context.request.query!.onlyBody === 'true') {
        return null;
    }
    /* VSI Customization - END */

    return (
        <Module {...moduleProps}>
            <Node {...contentProps}>
                {newsletterheading}
                {newsletterDescription}
                {joinNow}
            </Node>
            {subscribeForm}
        </Module>
    );
};
